import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface SelectionCardProps {
  title: string;
  description?: string;
  icon?: LucideIcon | React.ElementType;
  selected: boolean;
  onClick: () => void;
  className?: string;
  extra?: React.ReactNode;
}

export function SelectionCard({
  title,
  description,
  icon: Icon,
  selected,
  onClick,
  className,
  extra
}: SelectionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        "flex flex-col items-start text-left p-4 rounded-xl border-2 transition-all w-full min-h-24 focus:outline-none focus:ring-2 focus:ring-amber-300 focus:ring-offset-1",
        selected
          ? "border-amber-500 bg-amber-50/50 shadow-sm"
          : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50",
        className
      )}
    >
      <div className="flex items-center gap-3 mb-2 w-full">
        {Icon && (
          <div className={cn("p-2 rounded-lg", selected ? "bg-amber-100 text-amber-600" : "bg-slate-100 text-slate-500")}>
            <Icon size={24} />
          </div>
        )}
        <h3 className={cn("font-semibold text-lg", selected ? "text-slate-900" : "text-slate-700")}>
          {title}
        </h3>
        {extra && <div className="ml-auto">{extra}</div>}
      </div>
      {description && (
        <p className={cn("text-sm", selected ? "text-slate-700" : "text-slate-500")}>
          {description}
        </p>
      )}
    </button>
  );
}
